import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';

@Injectable({
  providedIn: 'root'
})
export class CreateFormsCrChimneysweepConfirmationService {
  public form = new FormGroup({}, { updateOn: 'submit' });

  constructor(private fb: FormBuilder, private createFormsService: CreateFormsService) {}

  createChimneySweepForm() {
    return this.fb.group({
      uploads: this.fb.array([]),
      formConfirmation: ['', [Validators.required, this.mustTrue]]
    });
  }

  mustTrue(control) {
    const enteredValue = control.value;
    return !enteredValue ? { mustTrue: true } : null;
  }
}
